a<template>
  <div>
    <main class="mt-0">

      <div v-if="isLoading" class="saving-indicator">
        <span class="spinner"></span>데이터 로딩 중...
      </div>

      <div class="p-1">
        <h3 class="rd-page-title"><u>호텔예약 리스트</u></h3>
        <span style="color: crimson; font-size: 0.9rem; padding-left: 20px;">※ NTB상태와 RTX상태가 불일치하는 경우, 즉시 라쿠텐 예약상태 확인을 하십시오</span>

        <!-- ── 상단 필터 ── -->
        <div class="top-container d-flex align-items-center mb-2">

          <!-- 예약상태 -->
          <div class="flex-item">
            <select class="form-select form-select-sm" v-model="filterStatus" @change="applyFilters">
              <option value="">진행상태</option>
              <option value="bkg-ip">처리중</option>
              <option value="bkg-cf">확정</option>
              <option value="bkg-ps">공급사대기</option>
              <option value="bkg-af">실패</option>
              <option value="bkg-cx">취소</option>
            </select>
          </div>

          <!-- 지난예약 토글 -->
          <div class="flex-item">
            <select class="form-select form-select-sm" v-model="showPast" @change="applyFilters">
              <option :value="false">체크인未도래</option>
              <option :value="true">전체예약보기</option>
            </select>
          </div>

          <!-- 회원 구분 -->
          <div class="flex-item">
            <select class="form-select form-select-sm" v-model="filterMem" @change="applyFilters">
              <option value="">전체</option>
              <option value="Y">회원</option>
              <option value="N">비회원</option>
            </select>
          </div>

          <!-- 검색어 -->
          <div class="flex-item">
            <input
              v-model="searchKeyword"
              @input="applyFilters"
              type="text"
              class="form-control form-control-sm"
              placeholder="예약번호 · 신청자명 · 이메일 · 호텔명"
              style="width:250px;"
            />
          </div>

          <!-- 건수 표시 -->
          <div class="flex-item ms-3 text-muted small">
            전체 <strong>{{ allList.length }}</strong>건 &nbsp;/&nbsp; 표시 <strong>{{ filteredList.length }}</strong>건
          </div>

          <!-- 새로고침 -->
          <div class="flex-item ms-auto">
            <button class="btn btn-outline-secondary btn-sm" @click="loadList">
              <i class="bi bi-arrow-clockwise"></i> 새로고침
            </button>
          </div>

        </div>

        <!-- ── 합산 표시 바 ── -->
        <div style="
          display:flex; gap:1rem; flex-wrap:wrap; align-items:center;
          background:#f8f9ff; border:1px solid #e2e8f0; border-radius:8px;
          padding:.6rem 1.2rem; margin-bottom:.6rem; font-size:13px;
        ">
          <span style="font-weight:700; color:#444;">
            📊 확정 {{ summary.cfCount }}건
          </span>
          <span style="color:#ddd;">|</span>
          <span>
            판매가 &nbsp;
            <strong style="color:#1a6eb5;">
              {{ summary.selling.toLocaleString('ko-KR') }}원
            </strong>
          </span>
          <span style="color:#ddd;">|</span>
          <span>
            원가 &nbsp;
            <strong style="color:#555;">
              {{ summary.cost.toLocaleString('ko-KR') }}원
            </strong>
          </span>
          <span style="color:#ddd;">|</span>
          <span>
            마진 &nbsp;
            <strong :style="{ color: summary.margin > 0 ? '#27ae60' : '#e74c3c' }">
              {{ summary.margin.toLocaleString('ko-KR') }}원
            </strong>
          </span>
          <span style="color:#ddd;">|</span>
          <span>
            취소수수료 (취소 {{ summary.cxCount }}건) &nbsp;
            <strong style="color:#e67e22;">
              {{ summary.cancelFee.toLocaleString('ko-KR') }}원
            </strong>
          </span>
        </div>


        <!-- ── AG Grid ── -->
        <ag-grid-vue
          class="ag-theme-alpine"
          style="width:100%; height:calc(100vh - 190px);"
          :columnDefs="columnDefs"
          :rowData="filteredList"
          :defaultColDef="defaultColDef"
          :pagination="true"
          :paginationPageSize="100"
          :animateRows="true"
          rowSelection="single"
          @grid-ready="onGridReady"
          @row-clicked="onRowClicked"
        />

      </div>
    </main>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue3'

export default {
  components: { AgGridVue },

  data() {
    return {
      isLoading: false,
      gridApi:   null,

      allList:      [],   // 원본 전체
      filteredList: [],   // 필터 적용 결과

      filterStatus:  '',
      filterMem:     '',
      searchKeyword: '',

      defaultColDef: {
        resizable:       true,
        sortable:        true,
        filter:          true,
        suppressMovable: false,
        cellStyle:       { fontSize: '12px' }
      }, 

      showPast: false,   // 기본값: 지난예약 숨김      

      columnDefs: [
        // ── 상태 (배지) ──────────────────────────────────────────
        {
          headerName: 'NTB상태',
          field: 'status',
          width: 95,
          pinned: 'left',
          cellRenderer: (params) => {
            const map = {
              'bkg-ip': { label: '처리중',     bg: '#3498db' },
              'bkg-cf': { label: '확정',       bg: '#27ae60' },
              'bkg-ps': { label: '공급사대기', bg: '#e67e22' },
              'bkg-af': { label: '실패',       bg: '#e74c3c' },
              'bkg-cx': { label: '취소',       bg: '#95a5a6' }
            }
            const s = map[params.value] || { label: params.value || '-', bg: '#999' }
            return `<span style="
              background:${s.bg}; color:#fff; font-size:11px;
              padding:2px 7px; border-radius:4px; font-weight:600;
              white-space:nowrap;
            ">${s.label}</span>`
          }
        },
        {
          headerName: 'RTX상태',
          field: 'rtx_status',
          width: 90,
          pinned: 'left',
          cellRenderer: (params) => {
            if (!params.value) return '<span style="color:#ccc; font-size:11px;">-</span>'

            const map = {
              'bkg-ip': { label: '처리중',     color: '#3498db' },
              'bkg-cf': { label: '확정',       color: '#27ae60' },
              'bkg-ps': { label: '공급사대기', color: '#e67e22' },
              'bkg-af': { label: '실패',       color: '#e74c3c' },
              'bkg-cx': { label: '취소',       color: '#95a5a6' }
            }

            // ⭐ 자체DB 상태(params.data.status)와 RTX상태 비교
            const rtxVal = params.value
            const dbVal  = params.data.status
            const s      = map[rtxVal] || { label: rtxVal, color: '#999' }
            const isMismatch = rtxVal !== dbVal

            return `<span style="
              background:${s.color}; color:#fff; font-size:11px;
              padding:2px 6px; border-radius:4px; font-weight:600;
              ${isMismatch ? 'outline:2px solid #e74c3c;' : ''}
            ">${s.label}${isMismatch ? ' ⚠️' : ''}</span>`
          }
        },

        // ── 예약번호 (클릭 강조) ─────────────────────────────────
        {
          headerName: '예약번호',
          field: 'booking_no',
          width: 170,
          pinned: 'left',
          cellStyle: { color: '#1a6eb5', fontWeight: '700', cursor: 'pointer' }
        },

        // ── 신청자 정보 ─────────────────────────────────────────
        {
          headerName: '신청자',
          field: 'contact_name',
          width: 85
        },
        {
          headerName: '연락처',
          field: 'contact_no',
          width: 120
        },
        {
          headerName: '이메일',
          field: 'contact_email',
          width: 150
        },
        {
          headerName: '예약일',
          field: 'created_at',
          width: 120,
          valueFormatter: (p) => p.value ? String(p.value).slice(0, 10) : '-'
        },        

        // ── 호텔 / 객실 ─────────────────────────────────────────
        {
          headerName: '호텔명',
          field: 'hotel_name',
          width: 220,
          tooltipField: 'hotel_name'
        },
        {
          headerName: '객실',
          field: 'room_desc',
          width: 180,
          tooltipField: 'room_desc'
        },

        // ── 일정 ────────────────────────────────────────────────
        {
          headerName: '체크인',
          field: 'check_in',
          width: 100,
          valueFormatter: (p) => p.value ? String(p.value).slice(0, 10) : '-'
        },
        {
          headerName: '체크아웃',
          field: 'check_out',
          width: 100,
          valueFormatter: (p) => p.value ? String(p.value).slice(0, 10) : '-'
        },
        {
          headerName: '박/인원/실',
          field: 'night_count',
          width: 105,
          sortable: false,
          cellRenderer: (p) => {
            const d = p.data
            return `${d.night_count || 0}박 / ${d.adult_count || 0}명 / ${d.room_count || 0}실`
          }
        },

        // ── 금액 ─────────────────────────────────────────────────
        {
          headerName: '판매가',
          field: 'selling_krw',
          width: 115,
          type: 'numericColumn',
          valueFormatter: (p) => p.value != null ? Number(p.value).toLocaleString('ko-KR') + '원' : '-'
        },
        {
          headerName: '원가',
          field: 'cost_krw',
          width: 115,
          type: 'numericColumn',
          valueFormatter: (p) => p.value != null ? Number(p.value).toLocaleString('ko-KR') + '원' : '-'
        },
        {
          headerName: '마진',
          field: 'margin_krw',
          width: 105,
          type: 'numericColumn',
          cellStyle: (p) => ({
            fontSize: '12px',
            color:      p.value > 0 ? '#27ae60' : p.value < 0 ? '#e74c3c' : '#666',
            fontWeight: '700',
            textAlign:  'right'
          }),
          valueFormatter: (p) => p.value != null ? Number(p.value).toLocaleString('ko-KR') + '원' : '-'
        },
        {
          headerName: '취소수수료',
          field: 'cancel_fee',
          width: 105,
          type: 'numericColumn',
          valueFormatter: (p) => p.value ? Number(p.value).toLocaleString('ko-KR') + '원' : '-'
        },

        // ── 결제 ─────────────────────────────────────────────────
        // {
        //   headerName: '결제1',
        //   field: 'paidAmt_01',
        //   width: 105,
        //   type: 'numericColumn',
        //   valueFormatter: (p) => p.value ? Number(p.value).toLocaleString('ko-KR') + '원' : '-'
        // },
        // {
        //   headerName: '결제2',
        //   field: 'paidAmt_02',
        //   width: 105,
        //   type: 'numericColumn',
        //   valueFormatter: (p) => p.value ? Number(p.value).toLocaleString('ko-KR') + '원' : '-'
        // },
        // {
        //   headerName: '잔액',
        //   field: 'balance',
        //   width: 105,
        //   type: 'numericColumn',
        //   cellStyle: (p) => ({
        //     fontSize: '12px',
        //     color: (p.value > 0) ? '#e74c3c' : '#27ae60',
        //     textAlign: 'right'
        //   }),
        //   valueFormatter: (p) => p.value != null ? Number(p.value).toLocaleString('ko-KR') + '원' : '-'
        // },
        {
          headerName: '결제유형',
          field: 'payType',
          width: 80,
          cellRenderer: (p) => {
            if (p.value === 'fu') return '<span style="color:#27ae60;font-weight:700;">전액</span>'
            if (p.value === 'p1') return '<span style="color:#e67e22;font-weight:700;">부분</span>'
            return '<span style="color:#bbb;">-</span>'
          }
        },

        // ── 회원 / 확인 / 메일 ──────────────────────────────────
        {
          headerName: '회원',
          field: 'mem_flag',
          width: 65,
          cellRenderer: (p) =>
            p.value === 'Y'
              ? '<span style="color:#3498db;font-weight:700;">Y</span>'
              : '<span style="color:#bbb;">-</span>'
        },
        {
          headerName: '확인자',
          field: 'check_id',
          width: 85
        },
        {
          headerName: '메일발송',
          field: 'conf_mail',
          width: 82,
          cellRenderer: (p) =>
            p.value === 'Y'
              ? '<span style="color:#27ae60;font-weight:700;">✓</span>'
              : '<span style="color:#bbb;">-</span>'
        },

        // ── RTX ID (참고용, 우측에 배치) ────────────────────────
        {
          headerName: 'RTX코드',
          field: 'booking_id',
          width: 120,
          cellStyle: { color: '#999', fontSize: '11px' }
        },
        {
          headerName: '승인코드',
          field: 'hotel_conf_id',
          width: 120,
          cellStyle: { color: 'blue', fontSize: '11px' }
        }        
      ]
    }
  },

  created() {
    this.user = this.$store.state.user
  },

  computed: {
    user() {
      return this.$store.state.user
    },

    // ✅ 확정건 합산 (filteredList 기준 → 필터 바뀔 때마다 자동 갱신)
    summary() {
      const cfList = this.filteredList.filter(r => r.status === 'bkg-cf')
      const cxList = this.filteredList.filter(r => r.status === 'bkg-cx')

      const sum = (arr, field) => arr.reduce((acc, r) => acc + (Number(r[field]) || 0), 0)

      return {
        cfCount:    cfList.length,
        selling:    sum(cfList, 'selling_krw'),
        cost:       sum(cfList, 'cost_krw'),
        margin:     sum(cfList, 'margin_krw'),
        cancelFee:  sum(cxList, 'cancel_fee'),   // 취소수수료는 취소건 기준
        cxCount:    cxList.length,
      }
    }
  },

  mounted() {
    // 권한 체크
    if (this.user.handlerGrade >= 20 || this.user.handlerGrade == undefined) 
    {
      const swal = require('sweetalert2')
      swal.fire({ title: '로그인 필요', text: '접근권한 확인불가.', icon: 'error' })
      this.$router.push({ path: '/' })
      return
    }
    if (this.user.handlerId != undefined) 
    {
      document.getElementById('admin').style.display = 'block'
    }
    document.getElementById('user').style.display = 'none'

    this.loadList()
  },

  methods: {

    onGridReady(params) {
      this.gridApi = params.api
    },

    async loadList() {
      this.isLoading = true
      try 
      {
        const rows = await this.$api('/api/getHotelBookingList', { param: [{}] })
        this.allList = rows || []
        this.applyFilters()

        // ✅ bkg-ip / bkg-ps 예약상태의 무결성 유지를 위해 진행건은 RTX상태조회
        await this.fetchRtxPendingStatus()
      } 
      catch (e) 
      {
        console.error('[Ma_RtxReserveInfoList] 로드 오류:', e)
      } 
      finally 
      {
        this.isLoading = false
      }
    },

    // RTX상태 조회 (진행중/공급사대기 건 + 최근 7일 이내 종결건)
    async fetchRtxPendingStatus() {
      const cutoff = new Date()
      cutoff.setDate(cutoff.getDate() - 7)

      const targetList = this.allList.filter(r => {
        // 처리중 건: 날짜 무관 전체
        if (r.status === 'bkg-ip' || r.status === 'bkg-ps') return true

        // 최근 7일 이내 종결 건
        const updatedAt = r.updated_at ? new Date(r.updated_at) : null
        if (updatedAt && !isNaN(updatedAt.getTime()) && updatedAt >= cutoff) 
        {
          return r.status === 'bkg-cf' || r.status === 'bkg-cx'
        }
        return false
      })

      if (targetList.length === 0) return

      console.log(`[RTX상태확인] ${targetList.length}건 조회 시작`)

      for (const row of targetList) 
      {
        try 
        {
          const res = await this.$api('/api/rtx/getBookStatus', {
            param: [{ booking_id: row.booking_id }]
          })
          const target = this.allList.find(r => r.booking_id === row.booking_id)
          if (target) target.rtx_status = res.status || '-'

          await new Promise(r => setTimeout(r, 300))
        } 
        catch (e) 
        {
          console.warn(`[RTX상태확인] ${row.booking_id} 실패:`, e.message)
        }
      }

      this.applyFilters()
      console.log(`[RTX상태확인] 완료`)
    },

    applyFilters() {
      let list = [...this.allList]
      // ✅ 지난예약 필터 (기본: 오늘 이후 체크인만)
      if (!this.showPast) 
      {
        const today = new Date().toISOString().slice(0, 10)
        list = list.filter(r => {
          const checkIn = r.check_in ? String(r.check_in).slice(0, 10) : ''
          return checkIn >= today
        })
      }

      // 예약상태 필터
      if (this.filterStatus) 
      {
        list = list.filter(r => r.status === this.filterStatus)
      }

      // 회원 구분 필터
      if (this.filterMem) 
      {
        list = list.filter(r => r.mem_flag === this.filterMem)
      }

      // 검색어 필터 (예약번호 · 신청자명)
      if (this.searchKeyword.trim()) 
      {
        const kw = this.searchKeyword.trim().toLowerCase()
        list = list.filter(r =>
          (r.booking_no    || '').toLowerCase().includes(kw) ||
          (r.contact_name  || '').toLowerCase().includes(kw) ||
          (r.contact_email || '').toLowerCase().includes(kw) ||
          (r.hotel_name    || '').toLowerCase().includes(kw)
        )
      }

      this.filteredList = list
    },

    onRowClicked(params) {
      this.$router.push({ 
        path: '/Ma_RtxReserveInfo_detail', 
        query: { bookingNo: params.data.booking_no } 
      })
    },
  }
}
</script>

<style scoped>
.top-container {
  flex-wrap: wrap;
}
.flex-item {
  margin: 5px;
}

/* ── 로딩 인디케이터 (기존 패턴) ── */
.saving-indicator {
  position: fixed;
  top: 30%; left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 10px;
  padding: 2rem 2.5rem;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  font-size: 1.3rem;
  font-weight: bold;
  color: #007bff;
}
.spinner {
  width: 28px; height: 28px;
  border: 4px solid #e0e0e0;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  margin-right: 1rem;
  animation: spin 1s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

.rd-page-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--charcoal);
  margin: 0 0 0.4rem;
  padding-left: 20px;
}
</style>